import gql from 'graphql-tag';

export const GET_INDIVIDUAL_LISTING = gql`
	query GetIndividualListing($id: String!) {
		listing(id: $id) {
			id
			createdAt
			updatedAt
			type
			client {
				id
				name
				image
				role
			}
			services {
				id
				status
			}
			property {
				id
				address
				city
				state
				zipCode
				alias
				longitude
				latitude
			}
			status
			askingPrice
			squareFootage
			lotSize
			matterportModelId
			beds
			baths
			flags
			yearBuilt
			homeDescription
			neighborhoodDescription
		}
	}
`;
